module.exports = __webpack_public_path__ + "static/media/27.b582d7f2.jpg";